import { Spinner, useToast } from "@chakra-ui/react"
import { useEffect, useRef } from "react"
import Pathicon from "../pathicon/Pathicon"

const PopupAlert = ({
  success,
  error,
  loading,
  onClear,
  children,
  inverted,
  clearAfter = 5000
}) => {
  const toast = useToast()
  const toastIdRef = useRef()

  useEffect(() => {
    const toastOptions = {
      status: success || loading ? "success" : error ? "error" : "info",
      duration: clearAfter,
      isClosable: true,
      position: "bottom",
      title:
        success ||
        error ||
        children ||
        (loading && (loading?.title || "Loading...")) ||
        null,
      description: loading?.description || null,
      icon: success ? (
        <Pathicon icon="check" />
      ) : error ? (
        <Pathicon icon="x" />
      ) : loading ? (
        <Spinner />
      ) : undefined,
      containerStyle: {
        // Force light mode Close button.
        "& button": {
          color: "white !important"
        }
      },
      onCloseComplete: onClear
    }

    // Show a new toast if needed, or update the current one.
    if (success || error || loading) {
      if (toastIdRef.current) {
        toast.update(toastIdRef.current, toastOptions)
      } else {
        toastIdRef.current = toast(toastOptions)
      }
    }
  }, [success, error, loading, children, inverted, clearAfter, toast, onClear])

  return null
}

export default PopupAlert
